import { render, staticRenderFns } from "./FormControlTypeWeek.vue?vue&type=template&id=395c4223&scoped=true"
import script from "./FormControlTypeWeek.vue?vue&type=script&lang=js"
export * from "./FormControlTypeWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c4223",
  null
  
)

export default component.exports